import exerciseTypesDefinitions from '../definitions';
import migrations from '../migrations';
export const getExerciseTypeVersionValidator = (wantedType, wantedVersion) =>
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
exerciseTypesDefinitions[wantedType][wantedVersion].validate;
const migrate = (type, wantedVersion, startVersion, data) => {
  const typeMigrations = migrations[type];
  let version = startVersion;
  let updatedData = data;
  while (version !== wantedVersion) {
    // the last version has no migration, but it won't enter the loop
    const migration = typeMigrations[version];
    const validator = getExerciseTypeVersionValidator(type, version);
    if (migration) {
      if (validator(updatedData)) {
        const migrationResult = migration(updatedData);
        updatedData = migrationResult.data;
        version = migrationResult.version;
      } else {
        throw new TypeError("The data is not a valid '".concat(type, "' of version '").concat(version, "'.\n").concat(JSON.stringify(validator.errors)));
      }
    } else {
      break;
    }
  }
  return updatedData;
};
export const getExerciseTypeVersionAdapter = (wantedType, wantedVersion) => (type, version, data) => {
  if (type !== wantedType) {
    throw new TypeError("Cannot convert from '".concat(type, "' to '").concat(wantedType, "'."));
  }
  const updatedData = migrate(wantedType, wantedVersion, version, data);
  const validator = getExerciseTypeVersionValidator(wantedType, wantedVersion);
  if (!validator(updatedData)) {
    throw new TypeError("Cannot convert '".concat(type, "' from '").concat(version, "' to '").concat(wantedVersion, "'.\n").concat(JSON.stringify(validator.errors)));
  }
  return updatedData;
};